import { Grid } from "@mantine/core"
import { Icons } from "src/components/ui/Icons"
import { LinkCard } from "src/components/ui/LinkCard"

export const OperationsAdminHomeLinkCard = () => {

    return (
        <Grid mt="sm">
            <Grid.Col span={12}>
                <LinkCard 
                    label="Bookings"
                    icon={Icons.booking} 
                    to={"/bookings"} 
                    color={"yellow"}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <LinkCard 
                    label="Calendar"
                    icon={Icons.calendar} 
                    to={"/calendar"} 
                    color={"green.8"}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <LinkCard 
                    label="Areas"
                    icon={Icons.area} 
                    to={"/areas"} 
                    color={"blue.6"}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <LinkCard 
                    label="Talent"
                    icon={Icons.talent} 
                    to={"/talent"} 
                    color={"orange.6"}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <LinkCard 
                    label="Users"
                    icon={Icons.user} 
                    to={"/users"} 
                    color={"purple.6"}
                />
            </Grid.Col>
        </Grid>
    )
}